export const ContainsAll = (array_a, array_b) => {

    let success = array_a.every((val) => array_b.includes(val))
    return success
}
